import styled from "styled-components";
import { Text, colors, spacingExtender } from "ui-components";

const AppendixDialogWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* Dialog should take up the entire screen from the header down */
  height: calc(100vh - 60px);
  background-color: ${colors.white}
`;

const AppendixDialogHeader = styled.div`
  ${() => spacingExtender({ paddingT: 4, paddingB: 2 })};
  padding: 2.5rem 0 1.5rem 0;
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  color: ${colors.darkBlue};
`;

const AppendixTabbedContentWrapper = styled.div`
  display: flex;
  /* Fix for IE only (underscore) that fixes scrolling in appendix */
  /*   - Side-effect is that the "Done" button is at the bottom of the dialog */
  _flex-basis: 100%;
`;

const AppendixTabContent = styled.div`
  display: flex;
  flex-direction: column;
  ${() => spacingExtender({
      marginT: 4,
      marginH: 5,
      paddingH: 3,
      paddingV: 1
    })};
  background-color: ${colors.white};
  /* Enable scrolling if necessary */
  overflow-y: auto;

  /* Handle border for last appendix subsection */
  > div:last-of-type { border: none; }
`;

const AppendixTabHeader = styled.div`
  font-size: 1.75rem;
  font-weight: bold;
  text-align: center;
  color: ${colors.darkBlue};
  ${() => spacingExtender({ paddingT: 4 })}
`;

const AppendixSubsection = styled.div`
  border-bottom: 1px solid black;

  /* Handle border for appendix subsection last tip */
  > div:last-of-type { border: none; }
`;

const AppendixSubsectionHeader = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  ${() => spacingExtender({ paddingT: 3, paddingB: 1 })};
`;

const AppendixTipWrapper = styled.div`
  display: flex;
  /* Keep from shrinking in long sections */
  flex-shrink: 0;
  min-height: 45px;
  border-bottom: 1px solid ${colors.lightGrey};
`;

const AppendixTipContent = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  cursor: pointer;
  ${() => spacingExtender({ paddingH: 1, paddingV: 2 })};
`;

const AppendixTipText = styled(Text)`
  display: flex;
  align-items: center;
  font-weight: ${({ isBold }) => (isBold ? "bold" : "normal")};
`;

const AppendixSuggestedTipContent = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  padding: 1rem;
  color: ${({ isReadonly }) => (isReadonly ? colors.darkGrey : "inherit")};
  cursor: ${({ isReadonly }) => (isReadonly ? "inherit" : "pointer")};
`;

// Edit button for custom Suggested Tips
const TipEditButton = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  padding: 1rem;
  text-decoration: underline;
  cursor: pointer;
  color: maroon;
`;

// Suggested Tips edit-mode button container
const TipEditorButtons = styled.div`
  ${() => spacingExtender({ marginL: 2 })};
  margin-left: 10px;
`;

// Wrapper for the SuggestedTip being edited
const DraftComponentWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1rem;
  font-family: ${({ theme }) => theme.fonts.family.bookText};
  font-weight: ${({ theme }) => theme.fonts.weight.bookText};
  font-size: ${({ theme }) => theme.fonts.sizes.Text4};
`;

// Wrapper for the DraftJS editor
const EditorWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  margin-right: auto;
  font-size: 12px;
  cursor: text;

  div { width: 100%; }
`;

const AppendixDialogButtons = styled.div`
  /* Take up remaining space in short dialogs */
  flex-grow: 1;
  text-align: center;
  background-color: ${colors.whiteGrey};
  ${() => spacingExtender({ padding: 4 })};
`;

export {
  AppendixDialogWrapper,
  AppendixDialogHeader,
  AppendixTabbedContentWrapper,
  AppendixTabContent,
  AppendixTabHeader,
  AppendixSubsection,
  AppendixSubsectionHeader,
  AppendixTipWrapper,
  AppendixTipContent,
  AppendixTipText,
  AppendixSuggestedTipContent,
  TipEditButton,
  TipEditorButtons,
  DraftComponentWrapper,
  EditorWrapper,
  AppendixDialogButtons
};



// WEBPACK FOOTER //
// ./src/common/components/AppendixDialog/styled.js